import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import "@mdi/font/css/materialdesignicons.css";
import "leaflet/dist/leaflet.css";

Vue.use(Vuetify);

export default new Vuetify({});
